import React from 'react';
import { DialogNative } from './components/native.js';
import { DialogCustom } from './components/custom.js';
import {} from '../../utils/pick-data-props.js';
import {} from '../../utils/pick-a11y-props.js';
export const Dialog = (props) => {
    if (props.type === 'custom') {
        return React.createElement(DialogCustom, { ...props });
    }
    return React.createElement(DialogNative, { ...props });
};
Dialog.displayName = 'Dialog';
//# sourceMappingURL=index.js.map